import Vue from 'vue'
import TabelaComponent from './TabelaComponent'
import ErrosBox from './ErrosBoxComponent'
import ButtonSpinner from './ButtonSpinner'
import LoadingComponent from './LoadingComponent'
import LoadingFullComponent from './LoadingFullComponent'
import StatusComponent from './StatusComponent'
import BtnVoltar from './BtnVoltar'
import TempoSessao from './TempoSessao'
import DetalheComponent from './DetalheComponent'
import DetalheComponent2 from './DetalheComponent2'
import DetalheComponent3 from './DetalheComponent3'
import DetalheFormComponent from './DetalheFormComponent'
import PainelValorComponent from './PainelValorComponent'
import BoxComponent from './BoxComponent'

Vue.component('AppTabela', TabelaComponent)
Vue.component('AppErrosBox', ErrosBox)
Vue.component('AppBtnSpinner', ButtonSpinner)
Vue.component('AppLoading', LoadingComponent)
Vue.component('AppLoadingFull', LoadingFullComponent)
Vue.component('AppStatus', StatusComponent)
Vue.component('AppBtnVoltar', BtnVoltar)
Vue.component('AppTempoSessao', TempoSessao)
Vue.component('AppDetalhe', DetalheComponent)
Vue.component('AppDetalhe2', DetalheComponent2)
Vue.component('Detalhe', DetalheComponent3)
Vue.component('AppKV', DetalheComponent)
Vue.component('AppDetForm', DetalheFormComponent)
Vue.component('AppPainelValor', PainelValorComponent)
Vue.component('AppBox', BoxComponent)
